/* jshint browser:true */

/**
 * Handles simple header functionality.
 */
export default class SimpleHeader {
  constructor() {
    this.classNames = {
      headerOverlay: 'theme--header-overlay',
      scrolledToContent: 'js-simple-header--scrolled-to-content'
    };
  }

  /**
   * Initializes features.
   */
  init() {
    const hasHeaderOverlay = document
      .querySelector('.' + this.classNames.headerOverlay) !== null;

    if (hasHeaderOverlay) {
      this.watchScroll();
    }
  }

  /**
   * Watches for when the user scrolls to the primary content of the page, then
   * adds a class to the body element.
   */
  watchScroll() {
    const bodyEl = document.querySelector('body');
    const options = {
      threshold: [.2, .21]
    };
    const minIntersection = .2;
    let contentElements = document.querySelectorAll(
      '.featured-media, main>.section--full:first-child'
    );

    if (!contentElements || contentElements.length === 0) {
      // No featured image is available for intersection observer
      bodyEl.classList.add(this.classNames.scrolledToContent);

      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio <= minIntersection) {
          requestAnimationFrame(() => {
            bodyEl.classList.add(this.classNames.scrolledToContent);
          });
        } else {
          requestAnimationFrame(() => {
            bodyEl.classList.remove(this.classNames.scrolledToContent);
          });
        }
      });
    }, options);

    Array.from(contentElements).forEach(x => observer.observe(x));
  }
}
